import styled from "styled-components";
import { MAX_WIDTH_PAGE } from "../../styles";

export const GalleryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  & .image-gallery-icon {
    filter: none;
  }
  & .image-gallery-svg {
    background-color: white;
    opacity: 0.9;
    width: ${48 / 16}rem !important;
    height: ${48 / 16}rem !important;
    border-radius: 50%;
    padding: 8px;
    & polyline {
      color: ${({ theme }) => theme.palette.secondary.orange500};
    }
  }
  .image-gallery-image {
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      max-height: 560px !important;
    }
  }
  & .image-gallery-bullet {
    background-color: white;
    opacity: 0.45;
    box-shadow: none;
    &.active {
      opacity: 1;
    }
  }
  min-height: 300px; /* ou 60vw */
  
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    min-height: 400px;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: none;
  }
`;

export const InformationsAboutProperty = styled.div`
  margin: 12px auto;
  box-shadow:  0px 8px 10px 0px rgba(98, 97, 97, 0.24);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  padding: 12px 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      gap: 42px;
    }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
      gap: 42px;
    }
`;

export const PropertyCharacteristics = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  color: ${({ theme }) => theme.palette.greyscale.grey700};
  
  p {
    font-size: 13px;
    margin-left: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  > svg, > span {
    width: 18px;
    height: 18px;
    color: ${({ theme }) => theme.palette.primary.blue400};
  }
`;


export const WhatLocalHasContainer = styled.div`
  margin: 12px 0 32px;
  padding: 24px 0 0px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  
  > div {
    margin: 18px 12px 0px 12px;
  }
  
  @media(max-width: 767px){
    width: 330px;
    padding: 24px 12px;
  }
  
  @media(min-width: 1441px){
    > div {
      margin: 18px 24px 0px 0;
    }
  }
`;

export const InformationWrapper = styled.div`
  background-color: white;
  margin: 24px 16px 0;
  display: flex;
  flex-direction: column;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 48px 48px 0;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    flex-direction: row;
    align-items: flex-start;
    margin: 0px auto;
    padding: 48px 48px 24px;
    max-width: ${MAX_WIDTH_PAGE};
    position: relative;
  }
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  max-width: 100%;
  margin-right: auto;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    max-width: 653px;
  }
`;

export const HousingProgramWrapper = styled.div`
  margin: 12px 0 4px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 16px 0 8px;
  }
`;

export const TitleFavWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  
  & a {
    max-height: 40px;
  }
  
  & svg {
    min-width: 32px;
    min-height: 32px;
    padding: 6px;
    color: ${({ theme }) => theme.palette.greyscale.grey800};
    cursor: pointer;
    
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      min-width: 40px;
      min-height: 40px;
      padding: 8px;
    }
    
    &:last-child {
      margin-left: 16px;
    }
  }
`;

export const Title = styled.h2`
  font-family: "Plus Jakarta Sans";
  color: ${({ theme }) => theme.palette.black.default};
  font-weight: 700;
  margin-right: auto;
  font-size: ${16 / 16}rem;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${24 / 16}rem;
    line-height: unset;
  }
`;

export const LoadingGifImg = styled.img`
  width: 32px;
  height: 32px;
  padding: 8px;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 40px;
    height: 40px;
  }
`;

export const AddressWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
  gap: 8px;
  
  & svg {
    width: 24px;
    height: 24px;
  }
`;

export const Address = styled.p`
  font-family: "Mulish", sans-serif;
  font-size: ${14 / 16}rem;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${16 / 16}rem;
  }
`;

export const PriceMapIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
  width: 100%;
`;

export const Price = styled.h6`
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: ${24 / 16}rem;
  margin-right: auto;
  color: ${({ theme }) => theme.palette.primary.blue500};
  
  &::after {
    content: " /mês";
    color: ${({ theme }) => theme.palette.greyscale.grey300};
    font-weight: 400;
    font-size: ${16 / 16}rem;
    font-style: normal;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${32 / 16}rem;
  }
`;

export const MapIconWrapper = styled.button`
  font-family: "Inter", sans-serif;
  color: ${({ theme }) => theme.palette.greyscale.grey800};
  border-radius: 8px;
  border: 1px solid currentColor;
  background: transparent;
  padding: 8px;
  font-size: ${16 / 16}rem;
  align-items: center;
  cursor: pointer;
  display: flex;
  
  & svg {
    min-width: 20px;
    min-height: 20px;
    margin-left: 8px;
  }
  
  &.isActive {
    color: ${({ theme }) => theme.palette.primary.blue500};
  }
`;

export const DesktopUpHideWrapper = styled.div`
  width: 100%;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: none;
  }
`;

export const DesktopDownHideWrapper = styled.div`
  display: none;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: unset;
  }
`;